// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarUsuarioService } from "../services/atualizarUsuarioService";
import { atualizarEnderecoService } from "../services/atualizarEnderecoService";

// --------------------- Import Interface ---------------------
import { ValidacaoProprietario } from "../interfaces/ValidacaoProprietario";
import { cadastrarEnderecoService } from "../../../services/cadastrarEnderecoService";

export const useAtualizarDadosValidacaoProprietario = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const atualizarDados = async (
    id: number | undefined,
    dados: ValidacaoProprietario,
    enderecoId: number | undefined,
    enderecoDados: ValidacaoProprietario
  ) => {
    if (id && enderecoId) {
      const [dadosAtualizados, enderecoAtualizado] = await Promise.all([
        atualizarUsuarioService(id, dados),
        atualizarEnderecoService(enderecoId, enderecoDados),
      ]);
      return dadosAtualizados && enderecoAtualizado;
    }
    return false;
  };

  const atualizarDadosSemEndereco = async (
    id: number | undefined,
    dados: ValidacaoProprietario,
    enderecoId: number | undefined,
    enderecoDados: ValidacaoProprietario
  ) => {
    if (id && enderecoId === 0) {
      const dadosEndereco = {
        ...enderecoDados,
        usuarioId: id,
        paisId: 21,
      };

      const [dadosAtualizados, enderecoAtualizado] = await Promise.all([
        atualizarUsuarioService(id, dados),
        cadastrarEnderecoService(dadosEndereco),
      ]);
      return dadosAtualizados && enderecoAtualizado;
    }
    return false;
  };

  const atualizarDadosValidacaoProprietario = async (
    usuarioId: number | undefined,
    usuario: ValidacaoProprietario,
    enderecoUsuarioId: number,
    enderecoUsuario: ValidacaoProprietario,
    representanteId: number | undefined,
    representante: ValidacaoProprietario,
    enderecoRepresentanteId: number | undefined,
    enderecoRepresentante: ValidacaoProprietario
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    setSuccess(null);

    try {
      if (enderecoUsuarioId === 0) {
        const [usuarioAtualizado, representanteAtualizado] = await Promise.all([
          atualizarDadosSemEndereco(
            usuarioId,
            usuario,
            enderecoUsuarioId,
            enderecoUsuario
          ),
          atualizarDados(
            representanteId,
            representante,
            enderecoRepresentanteId,
            enderecoRepresentante
          ),
        ]);
        if (usuarioAtualizado || representanteAtualizado) {
          setIsSuccess(true);
          setSuccess("Atualização realizada com sucesso!");
        } else {
          setError("Erro na atualização.");
        }
      } else {
        const [usuarioAtualizado, representanteAtualizado] = await Promise.all([
          atualizarDados(
            usuarioId,
            usuario,
            enderecoUsuarioId,
            enderecoUsuario
          ),
          atualizarDados(
            representanteId,
            representante,
            enderecoRepresentanteId,
            enderecoRepresentante
          ),
        ]);

        if (usuarioAtualizado || representanteAtualizado) {
          setIsSuccess(true);
          setSuccess("Atualização realizada com sucesso!");
        } else {
          setError("Erro na atualização.");
        }
      }
    } catch (error) {
      console.error(error);
      setError("Ocorreu um erro inesperado.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizarDadosValidacaoProprietario,
    isLoading,
    isSuccess,
    error,
    success,
  };
};
